/**
 * 推送消息账号请求接口
 * @author 王振宇
 * @since 2022-04-30
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_PUSHMESSAGEUSER_PAGE_LIST: function GET_PUSHMESSAGEUSER_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushMessageUser/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_PUSHMESSAGEUSER_LIST: function GET_PUSHMESSAGEUSER_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushMessageUser/getList',
        method: 'get',
        params: data
      });
    },
    GET_PUSHMESSAGEUSER_INFO: function GET_PUSHMESSAGEUSER_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushMessageUser/info',
        method: 'get',
        params: data
      });
    },
    SAVE_PUSHMESSAGEUSER: function SAVE_PUSHMESSAGEUSER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushMessageUser/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_PUSHMESSAGEUSER: function UPDATE_PUSHMESSAGEUSER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushMessageUser/update',
        method: 'put',
        data: data
      });
    },
    DELETE_PUSHMESSAGEUSER: function DELETE_PUSHMESSAGEUSER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushMessageUser/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_PUSHMESSAGEUSER: function DELETE_BATCH_PUSHMESSAGEUSER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/pushMessageUser/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});